import { render, staticRenderFns } from "./results.vue?vue&type=template&id=89f4aa9a&scoped=true"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=89f4aa9a&prod&scoped=true&lang=css"
import style1 from "./results.vue?vue&type=style&index=1&id=89f4aa9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f4aa9a",
  null
  
)

export default component.exports